export enum FilterFlyoutIconName {
  ColorCheckmark = 'ColorCheckmark',
  Delete = 'Delete',
  Shirt = 'Shirt',
  Sort = 'Sort',
  SortAlt = 'SortAlt',
}

export const filterFlyoutIconAssets: {
  [key in FilterFlyoutIconName]: string;
} = {
  [FilterFlyoutIconName.ColorCheckmark]: require('./ic-checkmark-color.svg'),
  [FilterFlyoutIconName.Delete]: require('./ic-delete.svg'),
  [FilterFlyoutIconName.Shirt]: require('./ic-shirt.svg'),
  [FilterFlyoutIconName.Sort]: require('./ic-sort.svg'),
  [FilterFlyoutIconName.SortAlt]: require('./ic-sort-alt.svg'),
};
